import { createContext } from 'react';

/** The shell's right-rail element; `DocsRail` portals into it at `lg` and up. */
export const DocsRailTargetContext = createContext<HTMLElement | null>(null);
